<div class="">
  <div class="modal-body">
    <p><strong>Descripción: </strong>{{ data.Description }}</p>
    <p><strong>Ubicación: </strong>{{ data.Location }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="activeModal.close()">
      Cerrar
    </button>
  </div>
</div>
